import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46dd08b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manifold m-token-media" }

import { inject } from 'vue';
// @ts-expect-error -- This repo has weird module resolution
import { MediaDisplay } from '@manifoldxyz/vue-component-library';


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenMedia',
  setup(__props) {

const imageUrl: string = inject('image', '');
const animationUrl: string = inject('media', '');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(MediaDisplay), {
      animationUrl: _unref(animationUrl),
      imageUrl: _unref(imageUrl)
    }, null, 8, ["animationUrl", "imageUrl"])
  ]))
}
}

})